import React from 'react'
import { NextPageContext } from 'next'

import { requestHtmlContent } from 'common/services/html-content/actions'
import Resources from 'page-modules/resources/resources-page'
import withAuthPageHOC from 'components/auth-page-hoc'
import { SagaStore } from 'common/store'

class ResourcesIndex extends React.Component {
  static getInitialProps = ({ store, req }: NextPageContext & { store: SagaStore }) => {
    store.dispatch(
      requestHtmlContent({
        req,
        keys: ['resources/intro-text/title', 'resources/intro-text/subtitle'],
      }),
    )
    return {}
  }

  render() {
    return <Resources tab="collections" />
  }
}

export default withAuthPageHOC(ResourcesIndex)
